import { useWorkflows } from 'store/workflow';
import { WorkflowTranslationKeys } from 'intl/keys';
import { createEntityFilterInput } from '../common';

export const WorkflowFilterInput = createEntityFilterInput({
  useData: () => useWorkflows().workflows,
  transformData: (workflows) =>
    workflows.map((workflow) => ({
      _id: workflow._id,
      label: workflow.name ?? '',
    })),
  labelId: WorkflowTranslationKeys.workflow,
  id: 'workflow-filter',
});
